module.exports = __webpack_public_path__ + "media/sonido.08282020.mp3";